import { csx } from '@vtex/admin-ui'

const styles = {
  valueContentColumn: csx({
    display: 'flex',
    gap: '$space-2',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
  valueContent: csx({
    display: 'flex',
    gap: '$space-2',
    flexWrap: 'wrap',
  }),
  flexRow: csx({
    gap: '$space-2',
    flexDirection: 'row',
    alignItems: 'center',
  }),
  nameText: csx({
    display: 'block',
    minWidth: 0,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  }),
  progressiveDiscountContainer: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-2',
  }),
  arrow: csx({
    color: 'secondary',
  }),
  tag: csx({
    display: 'inline-block',
  }),
}

export default styles
